import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import ContextMenu from './ContextMenu';
import { ListItemIcon, ListItemText, MenuItem, MenuList, Paper } from '@mui/material';
import DownloadFile from './WorkflowGroupActions/DownloadFile';
import { DeleteInboundTemplate } from './WorkflowGroupActions';

function DocumentContextMenu({targetId}) {
    const { t } = useTranslation();
    const [templateModal, setTemplateModal] = useState(null);
    const TEMPLATE_MODALS = {
        MNU_DEL_SEL_DOC: "MNU_DEL_SEL_DOC",
        LBL_DOWNLOAD_DOC: "LBL_DOWNLOAD_DOC",
    };
    const handleTemplateModal = (modalType) => {
        return () => {
            setTemplateModal(modalType);
        };
    }
  return (
    <>
      <ContextMenu targetId={targetId}>
        <Paper elevation={3} style={{ width: "17rem" }}>
          <MenuList vertical="true">
            <MenuItem
              name={t("MNU_DEL_SEL_TEM")}
              onClick={handleTemplateModal(TEMPLATE_MODALS.MNU_DEL_SEL_DOC)}>
              <ListItemIcon>
                <span className={"DELETE"}></span>
              </ListItemIcon>
              <ListItemText>{t("ACTION_DELETE_FILE")}</ListItemText>
            </MenuItem>
            <MenuItem
              onClick={handleTemplateModal(TEMPLATE_MODALS.LBL_DOWNLOAD_DOC)}>
              <ListItemIcon>
                <span className="DOWNLOAD_TEMPLATE"></span>
              </ListItemIcon>
              <ListItemText>{t("DOWNLOAD_FILE")}</ListItemText>
            </MenuItem>
          </MenuList>
        </Paper>
      </ContextMenu>
        <DeleteInboundTemplate openModal={templateModal === TEMPLATE_MODALS.MNU_DEL_SEL_DOC} toggle={handleTemplateModal(null)} />
        <DownloadFile open={templateModal === TEMPLATE_MODALS.LBL_DOWNLOAD_DOC} toggle={handleTemplateModal(null)} />
    </>
  );
}

export default DocumentContextMenu